import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as Threedots } from "../../../assets/images/icons/threedotsFunnel.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/EditIconFunnel.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/icons/DeleteFunnel.svg";
import { ReactComponent as DraggableIcon } from "../../../assets/images/DraggableIcon.svg";
import { ReactComponent as AddIconStage } from "../../../assets/images/icons/AddIconStage.svg";
import { getTitleCase, predefinedColors } from "../../../utils/utilityFunctions/stringUtility";
import { ReactComponent as AddDisableIcon } from "../../../assets/images/icons/AddDisableIcon.svg";
import { ReactComponent as CircleIcon } from "../../../assets/images/icons/CircleIcon.svg";
import { ReactComponent as PlusIconWhite } from "../../../assets/images/icons/PlusIconWhite.svg";
import { ReactComponent as CloseIcon } from "../../../assets/images/icons/funnelCloseIcon.svg";

import FloatingList from "../../UniversalComponents/FloatingElement";
import InputComponent from "../../UniversalComponents/InputComponent";
import {
  useDeleteFunnelMutation,
  useDeleteFunnelStageMutation,
  useFetchFunnelStagesQuery,
  usePostCreateFunnelMutation,
  usePostCreateStageMutation,
  usePostDragFunnelStagesMutation,
} from "../../../utils/customer/funnelSlice";
import Button from "../../UniversalComponents/DefaultButton";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../../utils/alertSlice";
import ConfirmationDialog from "../../UniversalComponents/ConfirmationDialogMulti";
import { ReactComponent as NoFunnelIcon } from "../../../assets/images/icons/NoFunnelIcon.svg";
import useClickOutside from "../../../hooks/Screen/useClickOutside";
import AvatarName from "../../UniversalComponents/AvatarName";
import { hexToRgba } from "../../../utils/utilityFunctions/color";
import FloatingElement from "../../UniversalComponents/FloatingElement";
import { Dialog } from "@mui/material";
import LabelComponent from "../../UniversalComponents/LabelComponent";
import moment from "moment";

const FunnelDashBoardCore = ({
  activeFunnel,
  isNewFunnelBeingCreated,
  setNewFunnelBeingCreated,
  setActiveFunnel,
  refetchFunnelTypes,
  FunnelStages,
  RefetchStage,
  funnelType,
  isEditable,
  editableRef,
  setNewFunnelName,
  newFunnelName,
  setIsEditable,
  funnelStagesData,
  setFunnelStagesData,
  newFunnelColor,
  setNewFunnelColor,
  copyButtonRef,
  handleAddNewClick,
  isColorFunnelPaletteOpen,
  setIsFunnelColorPaletteOpen,
}) => {
  const [postCreateFunnel] = usePostCreateFunnelMutation();
  const [postCreateStage] = usePostCreateStageMutation();
  const [deleteFunnelStage] = useDeleteFunnelStageMutation();
  const [deleteFunnel] = useDeleteFunnelMutation();
  const [postDragFunnelStages] = usePostDragFunnelStagesMutation();

  const inputRef = useRef(null);
  const textareaRef = useRef(null);
  const [isFloatingListOpen, setIsFloatingListOpen] = useState(false);
  const [isViewMode, setIsViewMode] = useState(true);
  const [isStageAddMode, setStageAddMode] = useState(false);
  const [isColorPaletteOpen, setIsColorPaletteOpen] = useState(false);
  const [newStageBeingCreated, setIsNewStageBeingCreated] = useState("");
  const [stageDescription, setStageDescription] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [editStageId, setEditStageId] = useState(null);
  const [editStage, setEditStage] = useState({
    id: null,
    name: "",
    description: "",
    color: "#5F5E52",
  });
  const [editFunnelName, setEditFunnelName] = useState({
    id: null,
    funnel_name: "",
    funnel_color: "",
  });
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showFunnelConfirmation, setShowFunnelConfirmation] = useState(false);
  const [deletePayload, setDeletePayload] = useState(false);
  const [deleteFunnelPayload, setDeleteFunnelPayload] = useState(false);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [hoveredStageId, setHoveredStageId] = useState(null);
  const [focusedField, setFocusedField] = useState(null);
  const [stageFormVisibleFor, setStageFormVisibleFor] = useState({
    id: null,
    position: null,
  });

  const inputFunnelRef = useRef(null);
  const stageRefs = useRef({});
  const buttonref = useRef(null);
  const funnelEditBoxRef = useRef(null);
  const editableFunnelRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isNewFunnelBeingCreated && inputFunnelRef.current) {
      inputFunnelRef.current.focus();
    }
  }, [isNewFunnelBeingCreated]);

  useEffect(() => {
    if (hoveredStageId && stageRefs.current[hoveredStageId]) {
      stageRefs.current[hoveredStageId].scrollIntoView({
        behavior: "smooth",
        block: "nearest", // keeps it visible without big jumps
      });
    }
  }, [hoveredStageId]);

  const colorcloseoutsideclick = useClickOutside(() => {
    setIsColorPaletteOpen(false);
  });

  const floatinglistcloseoutsideclick = useClickOutside(() => {
    setIsFloatingListOpen(false);
    setNewFunnelBeingCreated(false);
  });

  const stageaddmodecloseoutsideclick = useClickOutside(() => {
    setStageAddMode(false);
  });

  const hoverStagecloseoutsideclick = useClickOutside(() => {
    setStageFormVisibleFor({ id: null, position: null });
    setIsNewStageBeingCreated(""); // reset title input
    setStageDescription(""); // reset description textarea
    setSelectedColor(""); // reset color
  });

  useEffect(() => {
    const activeItemOb = funnelType?.data?.find((item) => item.funnel_name === activeFunnel?.funnel_name);
    setActiveFunnel((prevFunnel) => ({ ...prevFunnel, ...activeItemOb }));
  }, [activeFunnel?.funnel_name, funnelType]);

  useEffect(() => {
    if (FunnelStages?.data) {
      setFunnelStagesData(FunnelStages.data);
    }
  }, [FunnelStages]);

  useEffect(() => {
    if (activeFunnel && !isNewFunnelBeingCreated) {
      // setNewFunnelName(activeFunnel.funnel_name);
      setNewFunnelColor(activeFunnel.funnel_color);
    }
  }, [activeFunnel, isNewFunnelBeingCreated]);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     const clickedInsideFunnelEdit = funnelEditBoxRef.current?.contains(event.target);
  //     const clickedInsideColorPalette = colorcloseoutsideclick.current?.contains(event.target);
  //     const clickedOnCopyButton = copyButtonRef.current?.contains(event.target);

  //     if (!clickedInsideFunnelEdit && !clickedInsideColorPalette && !clickedOnCopyButton) {
  //       setIsEditable(false);
  //       setIsColorPaletteOpen(false);

  //     }

  //     if (clickedInsideFunnelEdit) {
  //       setNewFunnelBeingCreated(false);
  //     }
  //   };

  //   if (isEditable || isColorPaletteOpen) {
  //     document.addEventListener("mousedown", handleClickOutside);
  //   }

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [isEditable, isColorPaletteOpen]);

  // Handle outside click  copy funnel_color
  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideFunnelEdit = funnelEditBoxRef.current?.contains(event.target);
      const clickedInsideColorPalette = colorcloseoutsideclick.current?.contains(event.target);
      const clickedOnCopyButton = copyButtonRef.current?.contains(event.target);

      if (!clickedInsideFunnelEdit && !clickedInsideColorPalette && !clickedOnCopyButton) {
        setIsEditable(false);
        setIsColorPaletteOpen(false);

        // Reset color to last saved one if closed without saving
        setNewFunnelColor((prevColor) => {
          const lastSavedFunnel = funnelType?.data?.find((f) => f.id === activeFunnel?.id);
          return lastSavedFunnel?.funnel_color || "#C5C5C5";
        });
      }

      if (clickedInsideFunnelEdit) {
        setNewFunnelBeingCreated(false);
      }
    };

    if (isEditable || isColorPaletteOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEditable, isColorPaletteOpen, funnelType, activeFunnel]);

  // Handle outside click for EDIT funnel + Color Palette
  useEffect(() => {
    const handleEditOutsideClick = (event) => {
      const clickedInsideFunnelEdit = editableFunnelRef.current?.contains(event.target);
      const clickedInsideColorPalette = colorcloseoutsideclick.current?.contains(event.target);

      if (!clickedInsideFunnelEdit && !clickedInsideColorPalette) {
        setEditFunnelName(null);
        // setIsColorPaletteOpen(false);
      }

      if (clickedInsideFunnelEdit) {
        setNewFunnelBeingCreated(false);
      }
    };

    if (editFunnelName) {
      document.addEventListener("mousedown", handleEditOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleEditOutsideClick);
    };
  }, [editFunnelName]);

  const handleCreateFunnel = async () => {
    const stageData = funnelStagesData.map((item) => ({
      stage_name: item.stage_name,
      description: item.description,
      color: item.color,
    }));

    const payload = {
      funnel_name: newFunnelName,
      funnel_color: newFunnelColor,
      stages: isNewFunnelBeingCreated ? [] : stageData,
    };

    postCreateFunnel({ payload })
      .unwrap()
      .then((response) => {
        dispatch(
          pushAlert({
            type: "success",
            message: response?.message || "Funnel created successfully",
            visible: true,
          })
        );
        setFunnelStagesData([]);
        setActiveFunnel({ funnel_name: newFunnelName, funnel_color: newFunnelColor });
        setNewFunnelName("");
        setNewFunnelColor("");
        refetchFunnelTypes();
        setNewFunnelBeingCreated(false);
        setIsFunnelColorPaletteOpen(false);
      })
      .catch((error) => {
        //duplicate funnel
        const messageFromBackend = error?.data?.message || error?.message || "An unknown error occurred";
        dispatch(
          pushAlert({
            type: "danger",
            message: messageFromBackend,
            visible: true,
          })
        );
      });
  };

  const handleStageAddMode = () => {
    setStageAddMode(!isStageAddMode);
    if (!isStageAddMode) {
      setEditStageId(null);
      setEditStage({ id: null, name: "", description: "", color: "#5F5E52" });
    }
  };

  const resetStageForm = () => {
    setStageAddMode(false);
    setStageFormVisibleFor({ id: null, position: null });
    setIsNewStageBeingCreated("");
    setStageDescription("");
    setSelectedColor("");
  };

  const handleCreateStage = async () => {
    const trimmedName = newStageBeingCreated.trim();
    const trimmedDescription = stageDescription.trim();

    if (!trimmedName) {
      dispatch(
        pushAlert({
          type: "danger",
          message: "Stage name cannot be empty.",
          visible: true,
        })
      );
      return;
    }

    const payload = {
      stage_name: trimmedName,
      description: trimmedDescription,
      color: selectedColor,
    };

    // Insert between logic
    if (stageFormVisibleFor?.id) {
      if (stageFormVisibleFor.position === "above") {
        payload.insert_before_stage_id = stageFormVisibleFor.id;
      } else if (stageFormVisibleFor.position === "below") {
        payload.insert_after_stage_id = stageFormVisibleFor.id;
      }
      // For "below last card" → no insert_before/after → backend will append
    }

    try {
      const response = await postCreateStage({
        funnelId: activeFunnel?.id,
        payload,
      }).unwrap();

      if (response?.status) {
        dispatch(
          pushAlert({
            type: "success",
            message: response?.message,
            visible: true,
          })
        );

        resetStageForm();
        setStageFormVisibleFor({ id: null, position: null }); // reset
        RefetchStage();
      }
    } catch (error) {
      const errorMessage = error?.data?.message || "Something went wrong. Please try again.";

      dispatch(
        pushAlert({
          type: "danger",
          message: errorMessage,
          visible: true,
        })
      );
    }
  };

  useEffect(() => {
    if (!isStageAddMode) {
      setIsNewStageBeingCreated("");
      setStageDescription("");
      setSelectedColor("");
    }
  }, [isStageAddMode]);

  useEffect(() => {
    if (isStageAddMode && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isStageAddMode]);

  useEffect(() => {
    // When funnel changes, close any open stage edits
    setEditStageId(null);
    setEditStage({ name: "", description: "", color: "#FFFFFF" });
  }, [activeFunnel]);

  useEffect(() => {
    setStageAddMode(false);
    setIsColorPaletteOpen(false);
  }, [activeFunnel?.funnel_name]);

  const handleSaveStageEdit = async ({ stage_id, stage_name, description, color }) => {
    const payload = {
      stage_id,
      stage_name,
      description,
      color,
    };

    try {
      const response = await postCreateStage({
        funnelId: activeFunnel.id,
        payload,
      }).unwrap();

      if (response.status) {
        dispatch(
          pushAlert({
            type: "success",
            message: response?.message || "Stage updated successfully.",
            visible: true,
          })
        );
        RefetchStage();
        refetchFunnelTypes();
      } else {
        dispatch(
          pushAlert({
            type: "danger",
            message: response?.error || "Failed to update stage.",
            visible: true,
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          type: "danger",
          message: error?.data?.message || "Something went wrong while saving stage.",
          visible: true,
        })
      );
    }
  };

  const handleEditStage = (item) => {
    if (isStageAddMode) return;
    setEditStageId(item.stage_id);
    setEditStage({
      id: item.stage_id,
      name: item.stage_name,
      description: item.description,
      color: item.color || "#5F5E52",
    });
  };

  // console.log(setEditStageId, "saumya");

  const handleDragStart = (index) => {
    console.log(" Drag Start - index:", index);
    setDraggedIndex(index);
  };

  const handleDragOver = (e) => {
    e.preventDefault(); // Required to allow drop
    console.log(" Drag Over - hovering over an item");
  };

  const handleDrop = async (dropIndex) => {
    console.log(" Drop Triggered - dropped at index:", dropIndex);
    console.log("Dragged From Index:", draggedIndex);
    if (draggedIndex === null || draggedIndex === dropIndex) {
      console.log(" Drop skipped: same position or invalid drag");
      return;
    }

    const updatedStages = [...FunnelStages.data];
    const draggedItem = updatedStages[draggedIndex];

    // Reordering the array
    updatedStages.splice(draggedIndex, 1);
    updatedStages.splice(dropIndex, 0, draggedItem);

    console.log("Updated Order:");
    updatedStages.forEach((item, idx) => {
      console.log(`   ${idx + 1}: ${item.stage_name} (${item.stage_id})`);
    });

    setDraggedIndex(null); // reset dragged index

    // Build payload for API
    const payload = {
      type_id: activeFunnel?.id ?? null,
      stages: updatedStages
        .filter((stage) => stage?.stage_id != null)
        .map((stage, idx) => ({
          stage_id: stage.stage_id,
          stage_rank: idx + 1,
          // stage_name: stage.stage_name ?? null,
          // color: stage.color ?? null,
          // description: stage.description ?? null,
        })),
    };

    console.log(" Payload to be sent to /stage-rank API:", payload);

    try {
      const response = await postDragFunnelStages({ payload }).unwrap();
      RefetchStage();
      console.log(" API Success: Stage order updated");

      dispatch(
        pushAlert({
          type: "success",
          message: response?.message || "Stage order updated successfully.",
          visible: true,
        })
      );
    } catch (err) {
      console.error(" API Error: Failed to update stage order", err);
      dispatch(
        pushAlert({
          type: "danger",
          message: err?.data?.message || "Failed to update stage order.",
          visible: true,
        })
      );
    }
  };

  const handleSaveFunnelEdit = async (funnel_id, funnel_name, funnel_color) => {
    if (!funnel_id || !funnel_name.trim()) {
      dispatch(
        pushAlert({
          type: "danger",
          message: "Funnel ID or name is missing.",
          visible: true,
        })
      );
      return;
    }

    const payload = {
      id: funnel_id,
      funnel_name: funnel_name.trim(),
      funnel_color: funnel_color,
    };

    try {
      const response = await postCreateFunnel({ payload }).unwrap();

      dispatch(
        pushAlert({
          type: "success",
          message: response?.message || "Funnel updated successfully",
          visible: true,
        })
      );

      // Update the UI
      setActiveFunnel((prev) => ({ ...prev, funnel_name: funnel_name, funnel_color: funnel_color }));
      setNewFunnelName(funnel_name.trim());

      // Reset edit state
      setEditFunnelName({ id: null, funnel_name: "", funnel_color: "" });
      setIsEditable(false);

      //  Refetch funnels list
      refetchFunnelTypes();
    } catch (error) {
      dispatch(
        pushAlert({
          type: "danger",
          message: error?.data?.message || error.message || "Failed to update funnel",
          visible: true,
        })
      );
    }
  };

  const handleDeleteConfirmation = (stageId) => {
    if (isStageAddMode) return;
    setDeletePayload(stageId);
    setShowConfirmation(stageId);
  };

  const handleDeleteStage = async (stageId) => {
    setShowConfirmation(false);
    if (!activeFunnel?.id || !stageId) return;

    try {
      const response = await deleteFunnelStage({
        funnelId: activeFunnel.id,
        stageId: stageId,
      }).unwrap();

      if (response?.status) {
        dispatch(pushAlert({ type: "success", message: response?.message, visible: true }));
      } else {
        dispatch(
          pushAlert({
            type: "danger",
            message: response?.message || "Delete failed",
            visible: true,
          })
        );
      }
    } catch (error) {
      // Catch errors like 4xx, 5xx or manual rejections
      dispatch(
        pushAlert({
          type: "danger",
          message: error?.data?.message || "An error occurred",
          visible: true,
        })
      );
    }

    RefetchStage();
  };

  const handleDeleteConfirmationFunnel = (funnelId) => {
    setDeleteFunnelPayload(funnelId);
    setShowFunnelConfirmation(funnelId);
  };

  const handleFunnelDelete = async (funnelId) => {
    setShowFunnelConfirmation(false);
    if (!funnelId) return;

    try {
      const response = await deleteFunnel(funnelId).unwrap();

      if (response?.status) {
        dispatch(
          pushAlert({
            type: "success",
            message: response?.message || "Funnel deleted successfully.",
            visible: true,
          })
        );
      } else {
        dispatch(
          pushAlert({
            type: "success",
            message: response?.message || "Delete failed.",
            visible: true,
          })
        );
      }

      //
      console.log("FUnal funnel LK", activeFunnel, funnelType);
      let funnelIndex = 0;
      funnelType.data.forEach((funnel, ind) => {
        if (funnel.id === activeFunnel.id) {
          funnelIndex = ind;
        }
      });

      console.log("FUnal funnel LK index", funnelIndex);

      // Reset UI state on success
      setIsFloatingListOpen(false);
      if (funnelIndex === funnelType.data.length - 1) setActiveFunnel(funnelType.data[funnelIndex - 1]);
      else setActiveFunnel(funnelType.data[funnelIndex + 1]);

      // setFunnelStagesData([]);
      setStageAddMode(false);
      refetchFunnelTypes();
    } catch (err) {
      // This block is hit when response is an error (e.g. active funnel)
      const errorMessage = err?.data?.message || err?.error || "Failed to delete funnel.";
      dispatch(
        pushAlert({
          type: "danger",
          message: errorMessage,
          visible: true,
        })
      );
    }
  };

  useEffect(() => {
    if (stageFormVisibleFor?.id) {
      inputRef.current?.focus();
    }
  }, [stageFormVisibleFor]);

  // Reusable Stage Creation Form
  const renderStageForm = (onCancel) => {
    return (
      <div>
        <div className="w-full bg-white border border-primary-80 rounded-md relative">
          <div className="relative">
            <div className="relative w-full">
              <input
                ref={inputRef}
                type="text"
                placeholder="Type heading..."
                value={newStageBeingCreated}
                onChange={(e) => {
                  if (e.target.value.length <= 25) {
                    setIsNewStageBeingCreated(e.target.value);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    if (newStageBeingCreated.trim()) {
                      textareaRef.current?.focus();
                    }
                  }
                }}
                className="w-full rounded-md px-3 py-2 text-sm font-normal text-[#333] placeholder-[#AFAFAF] border-none focus:outline-none focus:ring-transparent focus:border-transparent pr-12"
              />

              {/* Character counter (only visible on focus) */}
              <span
                className={`absolute right-12 top-1/2 -translate-y-1/2 text-[11px] text-[#666] font-normal ${
                  newStageBeingCreated.length > 0 ? "inline" : "hidden"
                }`}
              >
                {newStageBeingCreated.length}/25
              </span>
            </div>

            <div className="absolute right-3 top-1 flex items-center">
              <button type="button" onClick={() => setIsColorPaletteOpen(!isColorPaletteOpen)}>
                <i className="bi bi-palette-fill text-[#C5C5C5] text-xl" style={{ color: selectedColor }}></i>
              </button>
            </div>

            {isColorPaletteOpen && (
              <div className="absolute border border-[#E4E6E9] bg-white p-2 right-1 z-10 w-[235px] h-[120px] shadow-md">
                <div className="flex flex-wrap gap-2" ref={colorcloseoutsideclick}>
                  {predefinedColors.map((color, index) => (
                    <button
                      key={index}
                      className={`w-6 h-6 rounded border ${
                        selectedColor === color ? "ring-2 ring-offset-1 ring-[#333]" : ""
                      }`}
                      style={{ backgroundColor: color }}
                      onClick={() => {
                        setSelectedColor(color);
                        setIsColorPaletteOpen(false);
                      }}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="h-[1px] w-full bg-[#F0F5F9] my-1" />

          <div className="relative w-full">
            <textarea
              ref={textareaRef}
              placeholder="Enter Description"
              className="w-full h-[50px] resize-none rounded-md px-3 py-2 text-sm font-normal text-[#333] placeholder-[#AFAFAF] border-none focus:outline-none focus:ring-transparent focus:border-transparent overflow-hidden pr-12"
              rows={1}
              maxLength={100}
              value={stageDescription}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  if (stageDescription.trim()) {
                    handleCreateStage();
                  }
                }
              }}
              onChange={(e) => {
                let value = e.target.value;
                const lines = value.split("\n");
                if (lines.length > 1) value = lines.slice(0, 1).join("\n");
                if (value.length <= 100) setStageDescription(value);
              }}
            />

            {/* Character counter */}
            <span
              className={`absolute right-3 top-1/2 -translate-y-1/2 text-[11px] text-[#666] font-normal ${
                stageDescription.length > 0 ? "inline" : "hidden"
              }`}
            >
              {stageDescription.length}/100
            </span>
          </div>
        </div>

        <div className="mt-4 flex justify-start gap-3">
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleCreateStage}>
            Save
          </Button>
        </div>
      </div>
    );
  };

  const closeStageForm = () => {
    resetStageForm();
    setStageFormVisibleFor({ id: null, position: null });
  };

  return (
    <>
      {/* {console.log(isNewFunnelBeingCreated, "fsxs")} */}
      {isViewMode && (
        <div className="w-full h-full flex flex-col rounded-[5px]  border border-[#E4E6E9] bg-white ">
          <div className="flex flex-col justify-between h-full">
            <div
              className={`w-full flex justify-between items-center rounded-t-[4px] ${
                (!isNewFunnelBeingCreated && activeFunnel) || isNewFunnelBeingCreated
                  ? `h-0 py-8 px-3 ${
                      activeFunnel?.funnel_color && activeFunnel?.funnel_color !== "#FFFFFF" ? "" : "border-[#E4E6E9]"
                    }`
                  : ""
              }`}
              style={{
                borderLeftColor:
                  !isNewFunnelBeingCreated && activeFunnel?.funnel_color && activeFunnel?.funnel_color !== "#FFFFFF"
                    ? hexToRgba(activeFunnel?.funnel_color, 0.4)
                    : "#E4E6E9",
              }}
              ref={buttonref}
            >
              <Dialog open={isNewFunnelBeingCreated} onClose={() => setNewFunnelBeingCreated(false)}>
                <div className="w-[469px] bg-white rounded flex flex-col gap-2 justify-between h-full py-3 relative overflow-visible ">
                  <div className="flex justify-between items-center text-center px-4">
                    <span className="text-[#131313cc] font-semibold text-lg">Add Funnel</span>
                    <span className="hover:bg-[#F6F6F6] p-2 rounded-md group">
                      <CloseIcon
                        className="cursor-pointer fill-[#13131399] group-hover:fill-[#131313cc] "
                        onClick={() => setNewFunnelBeingCreated(false)}
                      />
                    </span>
                  </div>

                  {/* divider */}
                  <div className="h-[1.3px] bg-[#D2DAE1] w-full"></div>

                  <div className="px-4 py-1">
                    <LabelComponent className="text-[#434852] text-sm" labelText="Name" size={"small"} />
                    <div className="flex flex-col w-full relative">
                      <InputComponent
                        ref={inputFunnelRef}
                        placeholder="Enter funnel name"
                        value={newFunnelName}
                        onChange={(e) => setNewFunnelName(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleCreateFunnel();
                            setNewFunnelName("");
                            setIsFunnelColorPaletteOpen(false);
                          }
                        }}
                        maxLength={20}
                        autoFocus={true}
                        clickFocus={true}
                      />
                      {/* Show only if at least 1 character is typed */}
                      <div
                        className={`flex items-center absolute right-4   -translate-y-1/2 ${isColorFunnelPaletteOpen ? "top-[12%]" : "top-1/2"}`}
                      >
                        {/* Palette icon */}
                        <i
                          className={`bi bi-palette-fill text-base text-[#8E8E8E]  cursor-pointer `}
                          // style={{ color: newFunnelColor }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsFunnelColorPaletteOpen(!isColorFunnelPaletteOpen);
                          }}
                        />
                      </div>

                      {/* Color palette */}
                      {isColorFunnelPaletteOpen && (
                        <div className="pt-2">
                          <LabelComponent
                            className="text-[#434852] text-sm pt-2"
                            labelText="Select your preferred color "
                            size={"small"}
                          />
                          <div className={`py-2 border-b border-dashed custom-dash-bottom `}>
                            <div className="flex flex-wrap gap-2">
                              {predefinedColors.map((color, index) => (
                                <button
                                  key={index}
                                  className={`w-6 h-6 rounded-full border ${
                                    newFunnelColor === color ? "ring-2 ring-offset-1 ring-primary-80" : ""
                                  }`}
                                  style={{ backgroundColor: color }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setNewFunnelColor(color);
                                  }}
                                />
                              ))}
                            </div>
                          </div>
                          <span className="flex items-center gap-2 justify-end pt-2">
                            {/* Color circle */}
                            <span
                              className="w-5 h-5 rounded-full border "
                              style={{ backgroundColor: newFunnelColor }}
                            ></span>
                            <LabelComponent className="text-[#434852] text-sm" labelText="Selected" size="small" />
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="flex justify-end gap-3 pt-4">
                      <Button variant="secondary" onClick={() => setNewFunnelBeingCreated(false)}>
                        Cancel
                      </Button>
                      <Button variant="primary" onClick={handleCreateFunnel} isDisabled={!newFunnelName?.length}>
                        Add
                      </Button>
                    </div>
                  </div>
                </div>
              </Dialog>

              <>
                {/* for copy funnel */}
                {isEditable && !editStageId ? (
                  <div className="relative w-full" ref={funnelEditBoxRef}>
                    <InputComponent
                      placeholder="Enter funnel name"
                      value={newFunnelName}
                      onChange={(e) => setNewFunnelName(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleCreateFunnel();
                          setIsEditable(false);
                        }
                      }}
                      autoFocus
                      maxLength={35}
                      className="text-[#1D4469] font-poppins text-base capitalize font-semibold leading-[18px] border-[#ccc] outline-none w-full px-2 py-1 rounded"
                    />

                    <i
                      className="bi bi-palette-fill text-base text-[#8E8E8E] cursor-pointer absolute right-[105px] top-1/2 -translate-y-1/2"
                      // style={{ color: editFunnelName?.funnel_color || newFunnelColor }}
                      style={{
                        color:
                          newFunnelColor && newFunnelColor.toLowerCase() !== "#ffffff" ? newFunnelColor : "#C5C5C5",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsColorPaletteOpen(!isColorPaletteOpen);
                      }}
                    />

                    {/* Divider */}
                    <div className="w-[1px] h-6 bg-gray-300 absolute right-[92px] top-1/2 -translate-y-1/2"></div>

                    {/* Save Button */}
                    <button
                      className="flex item-center absolute right-5 top-1/2 -translate-y-1/2 bg-primary border border-primary text-white font-medium px-4 h-7 rounded-md cursor-pointer"
                      onClick={() => {
                        handleCreateFunnel();
                        setIsEditable(false);
                      }}
                    >
                      Save
                    </button>

                    {isColorPaletteOpen && (
                      <div
                        ref={colorcloseoutsideclick}
                        className="absolute border border-[#E4E6E9] rounded-md bg-white p-2 right-24 top-10 z-10 w-[235px] h-[120px] shadow-md"
                      >
                        <div className="flex flex-wrap gap-2">
                          {predefinedColors.map((color, index) => (
                            <button
                              key={index}
                              className={`w-6 h-6 rounded border ${
                                newFunnelColor === color ? "ring-2 ring-offset-1 ring-[#333]" : ""
                              }`}
                              style={{ backgroundColor: color }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setNewFunnelColor(color);
                                setIsColorPaletteOpen(false);
                              }}
                            />
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  // for edit funnel
                  <div
                    className="text-[#1D4469] font-poppins text-base  font-semibold leading-[18px] w-full"
                    ref={editableFunnelRef}
                  >
                    {editFunnelName?.id === activeFunnel?.id ? (
                      <div className="relative w-full">
                        <InputComponent
                          placeholder="Enter funnel name"
                          value={getTitleCase(editFunnelName?.funnel_name)}
                          maxLength={35}
                          onChange={(e) =>
                            setEditFunnelName((prev) => ({
                              ...prev,
                              funnel_name: e.target.value,
                            }))
                          }
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              const trimmed = editFunnelName?.funnel_name?.trim();
                              if (trimmed) {
                                handleSaveFunnelEdit(editFunnelName?.id, trimmed, editFunnelName?.funnel_color);
                              }
                            }
                          }}
                          onBlur={() => {
                            const trimmed = editFunnelName?.funnel_name?.trim();
                            if (trimmed) {
                              handleSaveFunnelEdit(editFunnelName?.id, trimmed, editFunnelName?.funnel_color);
                            }
                          }}
                          autoFocus
                          className="w-full text-base font-semibold text-[#1D4469] px-2 py-1 rounded"
                          icon={
                            <div className="relative flex items-center">
                              {/* Palette icon */}
                              <i
                                className="bi bi-palette-fill text-base  text-[#8E8E8E] cursor-pointer"
                                // style={{
                                //   color: editFunnelName?.funnel_color || newFunnelColor,
                                // }}
                                style={{
                                  color:
                                    !editFunnelName?.funnel_color ||
                                    editFunnelName?.funnel_color.toLowerCase() === "#ffffff"
                                      ? "#C5C5C5"
                                      : editFunnelName?.funnel_color || newFunnelColor,
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsColorPaletteOpen(!isColorPaletteOpen);
                                }}
                              />

                              {/* Divider */}
                              <div className="w-[1px] h-6 bg-gray-300 mx-3"></div>

                              {/* Save button */}
                              <button
                                className="bg-primary border border-primary text-white font-medium px-4 h-7 rounded-md cursor-pointer"
                                onClick={() => {
                                  const trimmed = editFunnelName?.funnel_name?.trim();
                                  if (trimmed) {
                                    handleSaveFunnelEdit(editFunnelName?.id, trimmed, editFunnelName?.funnel_color);
                                  }
                                }}
                              >
                                Save
                              </button>

                              {/* Color palette */}
                              {isColorPaletteOpen && (
                                <div
                                  ref={colorcloseoutsideclick}
                                  className="absolute border border-[#E4E6E9] rounded-md bg-white p-2 right-[80px] top-10 z-10 w-[235px] h-[120px] shadow-md"
                                >
                                  <div className="flex flex-wrap gap-2">
                                    {predefinedColors.map((color, index) => (
                                      <button
                                        key={index}
                                        className={`w-6 h-6 rounded border ${
                                          (editFunnelName?.funnel_color || newFunnelColor) === color
                                            ? "ring-2 ring-offset-1 ring-[#333]"
                                            : ""
                                        }`}
                                        style={{ backgroundColor: color }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setEditFunnelName((prev) => ({
                                            ...prev,
                                            funnel_color: color,
                                          }));
                                          setNewFunnelColor(color);
                                          setIsColorPaletteOpen(false);
                                        }}
                                      />
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          }
                        />
                      </div>
                    ) : (
                      <div
                        onDoubleClick={() =>
                          activeFunnel &&
                          setEditFunnelName({
                            id: activeFunnel?.id,
                            funnel_name: activeFunnel?.funnel_name,
                            funnel_color: activeFunnel?.funnel_color || newFunnelColor,
                          })
                        }
                        className="font-bold text-[#131313cc] px-2.5 py-1 rounded text-lg flex justify-between group items-center"
                      >
                        <div className="flex flex-col ">
                          {/* === Funnel Header === */}
                          <div className="flex items-center gap-4">
                            {funnelType?.data?.length > 0 && (
                              <CircleIcon
                                fill={
                                  !activeFunnel.funnel_color || activeFunnel.funnel_color.toLowerCase() === "#ffffff"
                                    ? "#13131324"
                                    : activeFunnel.funnel_color
                                }
                              />
                            )}

                            <span className="whitespace-pre text-[#131313cc]">
                              {getTitleCase(activeFunnel?.funnel_name)}
                            </span>

                            {activeFunnel?.state === "draft" && (
                              <span className="text-xs font-normal rounded px-2 py-[2px] text-[#13131399] border border-[#D2DAE1]">
                                (Draft)
                              </span>
                            )}
                          </div>

                          {funnelType?.data?.length > 0 && (
                            <div className="flex justify-between items-center gap-2 whitespace-nowrap overflow-hidden text-ellipsis">
                              {/* Created By */}
                              <div className="flex items-center gap-1 shrink-0">
                                <span className="text-[#13131380] font-normal text-[11px]">
                                  Created by{" "}
                                  <span className="text-[#131313cc] font-normal text-[11px]">
                                    {activeFunnel?.created_by},
                                  </span>
                                </span>
                                <span className="text-[#131313cc] font-normal text-[11px]">
                                  {moment(activeFunnel?.created_at).format("DD MMM YYYY, hh:mm A")}
                                </span>
                              </div>

                              <div className="w-[1px] h-[1rem] bg-[#13131380] shrink-0"></div>

                              {/* Updated By */}
                              <div className="flex items-center gap-1 shrink-0">
                                <span className="text-[#13131380] font-normal text-[11px]">
                                  Updated by{" "}
                                  <span className="text-[#131313cc] font-normal text-[11px]">
                                    {activeFunnel?.updated_by},
                                  </span>
                                </span>
                                <span className="text-[#131313cc] font-normal text-[11px]">
                                  {moment(activeFunnel?.updated_at).format("DD MMM YYYY, hh:mm A")}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>

                        {activeFunnel?.state === "draft" && funnelType?.data?.length > 0 && (
                          <div className=" gap-3 p-2 rounded-[5px] hidden group-hover:flex">
                            <div
                              onClick={() => {
                                setEditFunnelName({
                                  id: activeFunnel.id,
                                  funnel_name: activeFunnel.funnel_name,
                                  funnel_color: activeFunnel.funnel_color,
                                });
                                setIsFloatingListOpen(false);
                              }}
                            >
                              <EditIcon />
                            </div>
                            <div onClick={() => handleDeleteConfirmationFunnel(activeFunnel?.id)}>
                              <DeleteIcon className="hover:fill-[#F84545] fill-[#f84545b3]" />
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
                {/* {activeFunnel?.funnel_name && (
                    <div>
                      <button
                        className={`w-[33px] h-10 flex items-center justify-center rounded-[4px] bg-[#F5F5F5] transition-all ${
                          activeFunnel?.state === "active" ? "cursor-not-allowed opacity-60" : "cursor-pointer"
                        }`}
                        onClick={() => {
                          if (activeFunnel?.state === "active") return;
                          setIsFloatingListOpen((prev) => !prev);
                        }}
                        disabled={activeFunnel?.state === "active"}
                      >
                        <Threedots />
                      </button>
                    </div>
                  )} */}
              </>
            </div>

            {!activeFunnel?.funnel_name && !isNewFunnelBeingCreated && (
              <div className="flex items-center justify-center h-full w-full mb-14">
                <div className=" text-center font-Inter flex flex-col space-y-3">
                  <NoFunnelIcon className="mx-auto mb-2" />
                  <span className="text-[#131313cc] font-semibold text-base">No Funnel is Added!</span>
                  <span className="text-[#13131399] text-base font-normal">
                    Funnel helps you track how your projects <br /> goes in different stages. Think of it as <br /> your
                    success tracker
                  </span>

                  <span className="flex justify-center">
                    <Button
                      className="whitespace-nowrap flex items-center justify-center gap-2 px-1"
                      onClick={handleAddNewClick}
                    >
                      <PlusIconWhite className="w-4 h-4" />
                      <span className="text-sm font-normal">Add New</span>
                    </Button>
                  </span>
                </div>
              </div>
            )}

            {/* stages work  starts here */}
            {activeFunnel?.funnel_name && (
              <>
                <div
                  className={`flex flex-col pl-5 pr-3 min-h-0 grow overflow-y-auto thinscrollbar  ${activeFunnel?.funnel_name ? "border-t pt-4 mb-4" : ""}`}
                >
                  <style>
                    {`
                .thinscrollbar::-webkit-scrollbar {
                  width: 6px;
                  background-color: transparent;
                }

                .thinscrollbar::-webkit-scrollbar-thumb {
                  border-radius: 4px;
                  background-color: transparent;
                }

                .thinscrollbar:hover::-webkit-scrollbar-thumb {
                  background-color: grey;
                }

                .thinscrollbar {
                  scrollbar-width: thin;
                  scrollbar-color: transparent transparent;
                }

                .thinscrollbar:hover {
                  scrollbar-color: grey transparent;
                }
              `}
                  </style>
                  {funnelStagesData?.length < 1 ? (
                    <div className="flex items-center justify-center h-full w-full mb-14">
                      <div className=" text-center font-Inter flex flex-col space-y-3">
                        <NoFunnelIcon className="mx-auto mb-2" />
                        <span className="text-[#131313cc] font-semibold text-base">No stage Added!</span>
                        <span className="text-[#13131399] text-base font-normal">
                          Adding stage helps you track how your <br /> projects goes in different stages. Think of{" "}
                          <br /> it as your success tracker
                        </span>
                        <span className="flex justify-center">
                          <Button
                            className="whitespace-nowrap flex items-center justify-center gap-2 px-1"
                            onClick={handleStageAddMode}
                          >
                            <PlusIconWhite className="w-4 h-4" />
                            <span className="text-sm font-normal">Add New</span>
                          </Button>
                        </span>
                      </div>
                    </div>
                  ) : (
                    funnelStagesData?.map((item, index) => (
                      <div
                        draggable
                        onDragStart={() => handleDragStart(index)}
                        onDragOver={handleDragOver}
                        onDrop={() => handleDrop(index)}
                        key={item.stage_id || index}
                        // className={`flex w-full ${
                        //   index !== funnelStagesData.length - 1 ? "border-l-2 border-[#2999bc33]" : ""
                        // }`}
                      >
                        {console.log("saumyaid", item, item.stage_id)}

                        {/* <div className="h-full w-[25px] relative">
                          <span className="absolute -translate-x-1/2 bg-white p-1 ">
                            <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#2999BC] text-white text-sm p-2">
                              {index + 1}
                            </span>
                          </span>
                        </div> */}

                        {/* MAIN CONTENT */}
                        <div className="w-full">
                          {/* View and Edit Stage */}
                          <>
                            <div className="w-full">
                              <div
                                key={item.stage_id}
                                ref={(el) => (stageRefs.current[item.stage_id] = el)}
                                onMouseEnter={() => setHoveredStageId(item.stage_id)}
                                onMouseLeave={() => {
                                  setHoveredStageId(null);
                                  if (isColorPaletteOpen === item.stage_id) {
                                    setIsColorPaletteOpen(null);
                                  }
                                }}
                                className="group"
                              >
                                {/* AddIcon ABOVE only for first stage */}
                                {activeFunnel?.state !== "active" &&
                                  index === 0 &&
                                  hoveredStageId === item.stage_id &&
                                  (stageFormVisibleFor.id !== item.stage_id ||
                                    stageFormVisibleFor.position !== "above") && (
                                    <div className="flex justify-center items-center pb-2">
                                      <AddIconStage
                                        className="cursor-pointer fill-primary hover:fill-primary-80"
                                        onClick={() => setStageFormVisibleFor({ id: item.stage_id, position: "above" })}
                                      />
                                    </div>
                                  )}

                                {/* Stage form ABOVE */}
                                {stageFormVisibleFor.id === item.stage_id &&
                                  stageFormVisibleFor.position === "above" &&
                                  !isStageAddMode && (
                                    // <div className="mb-4" ref={hoverStagecloseoutsideclick}>
                                    <div className="mb-4">
                                      {renderStageForm(() => {
                                        resetStageForm();
                                        setStageFormVisibleFor({ id: null, position: null });
                                      })}
                                    </div>
                                  )}

                                {/* Main stage card */}
                                <div
                                  className={`relative flex flex-col rounded-[5px] pt-2 pb-2 pl-4 border  transition-all duration-500 ease-in-out ${
                                    hoveredStageId === item.stage_id ? "bg-[#F8FAFF]" : ""
                                  }`}
                                >
                                  {/* top row */}
                                  <div
                                    className={`flex items-center justify-between pr-4 ${
                                      activeFunnel?.state === "active" ? "cursor-not-allowed" : "cursor-pointer"
                                    }`}
                                  >
                                    <div className="flex gap-3 items-center w-full">
                                      <DraggableIcon
                                        className={`fill-[#666666] ${
                                          activeFunnel?.state === "active"
                                            ? "cursor-not-allowed opacity-30"
                                            : "cursor-grab"
                                        }`}
                                      />

                                      <span
                                        className="flex items-center gap-2 text-[#383838] font-poppins font-normal text-[11px] rounded-md"
                                        style={{
                                          backgroundColor:
                                            item.color && item.color !== "#FFFFFF"
                                              ? hexToRgba(item.color, 0.08)
                                              : "#E4E6E9",
                                          padding: "2px 6px",
                                        }}
                                      >
                                        <CircleIcon
                                          fill={item.color && item.color !== "#FFFFFF" ? item.color : "#383838"}
                                        />
                                        <span
                                          style={{
                                            color: item.color && item.color !== "#FFFFFF" ? item.color : "#383838",
                                          }}
                                        >
                                          Stage {index + 1}
                                        </span>
                                      </span>

                                      {/* ==== Stage Name Input with Counter Inside ==== */}
                                      <div className="flex-1 relative input-wrapper pr-16">
                                        <input
                                          type="text"
                                          className={`w-full text-[13px] !font-semibold text-[#131313cc] capitalize bg-transparent 
                                                    border-0 focus:outline-none focus:ring-0 pr-12
                                                    ${
                                                      activeFunnel?.state === "active"
                                                        ? "cursor-not-allowed"
                                                        : "cursor-pointer hover:shadow-[inset_0_-1px_0_0_#E4E6E9] focus:shadow-[inset_0_-1px_0_0_#246BFD]"
                                                    }`}
                                          defaultValue={item.stage_name}
                                          readOnly={activeFunnel?.state === "active"}
                                          maxLength={25}
                                          onFocus={(e) => {
                                            if (stageFormVisibleFor.id) closeStageForm();
                                            setFocusedField(item.stage_id + "-name");
                                          }}
                                          onBlur={(e) => {
                                            setFocusedField(null);
                                            if (activeFunnel?.state === "active") return;
                                            const value = e.target.value.trim();
                                            if (value !== item.stage_name) {
                                              handleSaveStageEdit({
                                                stage_id: item.stage_id,
                                                stage_name: value,
                                                description: item.description,
                                                color: item.color,
                                              });
                                            }
                                          }}
                                          onInput={(e) => {
                                            if (focusedField === item.stage_id + "-name") {
                                              const counter = e.currentTarget
                                                .closest(".input-wrapper")
                                                ?.querySelector(".char-counter");
                                              if (counter) counter.textContent = `${e.currentTarget.value.length}/25`;
                                            }
                                          }}
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") e.currentTarget.blur();
                                          }}
                                        />

                                        {/* Counter for input */}
                                        {activeFunnel?.state !== "active" && (
                                          <span
                                            className={`absolute right-20 top-1/2 -translate-y-1/2 text-[11px] text-[#131313cc] font-normal char-counter pointer-events-none ${
                                              focusedField === item.stage_id + "-name" ? "inline" : "hidden"
                                            }`}
                                          >
                                            {item.stage_name?.length || 0}/25
                                          </span>
                                        )}
                                      </div>
                                    </div>

                                    {/* Color Palette + Delete (only visible on hover) */}
                                    <div className="relative">
                                      <div
                                        className={`absolute right-0 top-0 bottom-2 hidden group-hover:flex items-center gap-4 ${
                                          activeFunnel?.state === "active"
                                            ? "cursor-not-allowed opacity-30"
                                            : "cursor-pointer"
                                        }`}
                                      >
                                        <DeleteIcon
                                          className="hover:fill-[#F84545] fill-[#f84545b3]"
                                          onClick={() => {
                                            if (isStageAddMode || activeFunnel?.state === "active") return;
                                            if (stageFormVisibleFor.id) closeStageForm();
                                            handleDeleteConfirmation(item.stage_id);
                                          }}
                                        />

                                        <button
                                          type="button"
                                          onClick={() => {
                                            if (stageFormVisibleFor.id) closeStageForm();
                                            setIsColorPaletteOpen(
                                              isColorPaletteOpen === item.stage_id ? null : item.stage_id
                                            );
                                          }}
                                        >
                                          <i
                                            className={`bi bi-palette-fill text-xl ${
                                              activeFunnel?.state === "active"
                                                ? "cursor-not-allowed "
                                                : "cursor-pointer"
                                            }`}
                                            style={{
                                              color:
                                                !item.color || item.color.toLowerCase() === "#ffffff"
                                                  ? "#C5C5C5"
                                                  : item.color,
                                            }}
                                          ></i>
                                        </button>
                                      </div>

                                      {isColorPaletteOpen === item.stage_id && activeFunnel?.state !== "active" && (
                                        <FloatingElement mode="vertical" xMargin={0} margin={8}>
                                          <div className="absolute right-0 top-full mt-4 border border-[#E4E6E9] rounded-md bg-white p-2 w-[235px] h-[120px] shadow-md z-50">
                                            <div className="flex flex-wrap gap-2" ref={colorcloseoutsideclick}>
                                              {predefinedColors.map((color, idx) => (
                                                <button
                                                  key={idx}
                                                  className={`w-6 h-6 rounded border ${
                                                    item.color === color ? "ring-2 ring-offset-1 ring-[#333]" : ""
                                                  }`}
                                                  style={{ backgroundColor: color }}
                                                  onClick={() => {
                                                    if (activeFunnel?.state === "active") return;
                                                    handleSaveStageEdit({
                                                      stage_id: item.stage_id,
                                                      stage_name: item.stage_name,
                                                      description: item.description,
                                                      color: color,
                                                    });
                                                    setIsColorPaletteOpen(null);
                                                  }}
                                                />
                                              ))}
                                            </div>
                                          </div>
                                        </FloatingElement>
                                      )}
                                    </div>
                                  </div>

                                  {/* ==== Description Textarea with Counter Outside ==== */}
                                  <div className="desc-wrapper relative mx-[9px]">
                                    <textarea
                                      className={`w-full text-sm font-normal text-[#666666] bg-transparent border-0 h-[50px] 
                                      focus:outline-none focus:ring-0 resize-none
                                      ${
                                        activeFunnel?.state === "active"
                                          ? "cursor-not-allowed"
                                          : "cursor-pointer hover:shadow-[inset_0_-1px_0_0_#E4E6E9] focus:shadow-[inset_0_-1px_0_0_#246BFD]"
                                      }`}
                                      rows={1}
                                      maxLength={100}
                                      defaultValue={item.description}
                                      readOnly={activeFunnel?.state === "active"}
                                      onFocus={(e) => {
                                        if (stageFormVisibleFor.id) closeStageForm();
                                        setFocusedField(item.stage_id + "-desc");
                                      }}
                                      onBlur={(e) => {
                                        setFocusedField(null);
                                        if (activeFunnel?.state === "active") return;
                                        const value = e.target.value.trim();
                                        if (value !== item.description) {
                                          handleSaveStageEdit({
                                            stage_id: item.stage_id,
                                            stage_name: item.stage_name,
                                            description: value,
                                            color: item.color,
                                          });
                                        }
                                      }}
                                      onInput={(e) => {
                                        if (focusedField === item.stage_id + "-desc") {
                                          const counter = e.currentTarget
                                            .closest(".desc-wrapper")
                                            ?.querySelector(".desc-counter");
                                          if (counter) counter.textContent = `${e.currentTarget.value.length}/100`;
                                        }
                                      }}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter" && !e.shiftKey) {
                                          e.preventDefault();
                                          e.currentTarget.blur();
                                        }
                                      }}
                                    />

                                    {/* Counter for textarea */}
                                    {activeFunnel?.state !== "active" && (
                                      <span
                                        className={`block text-right text-[11px] text-[#666] font-normal  desc-counter ${
                                          focusedField === item.stage_id + "-desc" ? "block" : "hidden"
                                        }`}
                                      >
                                        {item.description?.length || 0}/100
                                      </span>
                                    )}
                                  </div>
                                </div>

                                {/* AddIcon BELOW */}

                                {activeFunnel?.state !== "active" &&
                                  hoveredStageId === item.stage_id &&
                                  (stageFormVisibleFor.id !== item.stage_id ||
                                    stageFormVisibleFor.position !== "below") && (
                                    <div className="flex justify-center items-center pt-2">
                                      <AddIconStage
                                        className="cursor-pointer fill-primary hover:fill-primary-80"
                                        onClick={() => setStageFormVisibleFor({ id: item.stage_id, position: "below" })}
                                      />
                                    </div>
                                  )}

                                {/* Stage form BELOW */}

                                {stageFormVisibleFor.id === item.stage_id &&
                                  stageFormVisibleFor.position === "below" &&
                                  !isStageAddMode && (
                                    // <div className="mt-4" ref={hoverStagecloseoutsideclick}>
                                    <div className="mt-4">
                                      {renderStageForm(() => {
                                        resetStageForm();
                                        setStageFormVisibleFor({ id: null, position: null });
                                      })}
                                    </div>
                                  )}
                              </div>

                              <div className="h-[10px]"></div>
                            </div>
                          </>
                        </div>
                      </div>
                    ))
                  )}
                </div>

                <div
                  className={`py-4 ${
                    activeFunnel?.funnel_name && funnelStagesData.length > 0 ? "border-none " : ""
                  } border-[#E4E6E9] px-4 relative h-fit`}
                  ref={stageaddmodecloseoutsideclick}
                >
                  {isStageAddMode ? (
                    <>
                      {renderStageForm(() => {
                        resetStageForm();
                      })}
                    </>
                  ) : (
                    activeFunnel?.funnel_name && (
                      <div className="items-center relative overflow-visible">
                        {activeFunnel?.state === "active" ? (
                          // Disabled-looking Add Stage
                          <div className="flex items-center gap-4 justify-center">
                            {/* <button className="rounded-full w-8 h-8 flex items-center justify-center opacity-80 transition-opacity cursor-not-allowed">
                              <AddDisableIcon />
                            </button> */}
                          </div>
                        ) : (
                          funnelStagesData.length > 0 && (
                            <div className=" flex items-center gap-4 justify-center">
                              {/* <div className="w-8 h-8 rounded-full flex items-center justify-center">
                                <AddIconStage className="cursor-pointer" onClick={handleStageAddMode} />
                              </div> */}
                            </div>
                          )
                        )}
                      </div>
                    )
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {console.log(activeFunnel?.funnel_name, "saumya")}

      {showConfirmation && (
        <ConfirmationDialog
          open={showConfirmation}
          onConfirm={() => handleDeleteStage(deletePayload)}
          onClose={() => setShowConfirmation(false)}
          title="Delete Stage?"
          message={<>This stage will be permanently removed from the funnel . Do you want to proceed?</>}
          confirmVariant="delete"
          iconVariant="delete"
          confirmText="Delete"
          cancelText="Cancel"
        />
      )}

      {showFunnelConfirmation && (
        <ConfirmationDialog
          open={showFunnelConfirmation}
          onConfirm={() => handleFunnelDelete(deleteFunnelPayload)}
          onClose={() => setShowFunnelConfirmation(false)}
          title="Delete Funnel?"
          message={
            <>
              Are you sure you want to delete this funnel?
              <br />
              This funnel contains multiple stages. Deleting it will permanently remove all associated .
            </>
          }
          confirmVariant="delete"
          iconVariant="delete"
          confirmText="Delete"
          cancelText="Cancel"
        />
      )}
    </>
  );
};

export default FunnelDashBoardCore;
